import React, { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { FiAlignRight, FiXCircle, FiChevronDown } from "react-icons/fi";
import './Navbarmenu.css';
import { useMsal } from "@azure/msal-react";
// import '/node_modules/bootstrap/dist/css/bootstrap.min.css'

const Navbarmenu = () => {
    const [isMenu, setisMenu] = useState(false);
    const [isResponsiveclose, setResponsiveclose] = useState(false);
    const toggleClass = () => {
        setisMenu(isMenu === false ? true : false);
        setResponsiveclose(isResponsiveclose === false ? true : false);
    };
    let boxClass = ["main-menu"];
    if (isMenu) {
        boxClass.push('menuq2');
    } else {
        boxClass.push('');
    }

    const AdminUsers = [
        "h.srinivasan",
        "varsha.a.tyagi",
        "jeevadharani.ramanan",
        "arpita.m.singh",
        "ankur.e.mishra",
        "uma.rani.battu",
        "d.kumari.vaishnava",
        "d.d.choudhary"
       ];
       const { instance } = useMsal();
       const activeAccount = instance.getActiveAccount();
       let loggedInEnterpriseId = "";
       if (activeAccount) loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;

    return (
        <header className="header__middle">
            <div className="head-container">
                <div className="row">
                    <div className="header__middle__menus">
                        <nav className="main-nav " >
                            {/* Responsive Menu Button */}
                            {isResponsiveclose === true ? <>
                                <span className="menubar__button" style={{ display: 'none' }} onClick={toggleClass} > <FiXCircle />   </span>
                            </> : <>
                                <span className="menubar__button" style={{ display: 'none' }} onClick={toggleClass} > <FiAlignRight />   </span>
                            </>}
                            <ul className={boxClass.join(' ')}>
                                <li className="menu-item">
                                    <NavLink activeClassName='is-active' className="nav-links" onClick={toggleClass} to={`/dashboard`}> Dashboard </NavLink>
                                </li>
                                { AdminUsers.includes(loggedInEnterpriseId) ? (
                                <li className="menu-item">
                                    <NavLink activeClassName='is-active' className="nav-links" onClick={toggleClass} to={`/projectMaster`}> Project Master </NavLink>
                                </li>
                                ) : null }
                                <li className="menu-item">
                                    <NavLink activeClassName='is-active' className="nav-links" onClick={toggleClass} to={`/dailyTaskUpdate`}> Daily Task Update </NavLink>
                                </li>
                                <li className="menu-item">
                                    <NavLink activeClassName='is-active' className="nav-links" onClick={toggleClass} to={`/individualTaskDashboard`}> Individual Task Dashboard </NavLink>
                                </li>
                                { AdminUsers.includes(loggedInEnterpriseId) ? (
                                <li className="menu-item">
                                    <NavLink activeClassName='is-active' className="nav-links" onClick={toggleClass} to={`/teamStatus`}> Team Status </NavLink>
                                </li>
                                ) : null }
                                 <li className="menu-item">
                                    <NavLink activeClassName='is-active' className="nav-links" onClick={toggleClass} to={`/userMaintenance`}> User Maintenance </NavLink>
                                </li>
                                <li className="menu-item">
                                    <NavLink activeClassName='is-active' className="nav-links" onClick={toggleClass} to={`/ProjectArtifacts`}> Project Artifacts </NavLink>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </header>
    )
}

export default Navbarmenu
